import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

class ReportRepository {
  static getBackendError(error) {
    const backendError = error?.details?.error || error?.details || error;
    const normalizedError = new Error(
      backendError?.message || error?.message || 'Unknown backend error',
    );

    normalizedError.code = backendError?.status || error?.code || 'unknown';
    normalizedError.details = backendError?.details || error?.details || null;

    return normalizedError;
  }

  async editWorkJourneyMark(markData, organizationId) {
    try {
      const createAttendanceEventFn = apiCallable(API_OPERATIONS.NEW_ATTENDANCE_EVENT);
      const payload = {
        ...markData,
        organizationId: markData?.organizationId || organizationId,
      };
      const response = await createAttendanceEventFn(payload);
      return response?.data || response;
    } catch (error) {
      throw ReportRepository.getBackendError(error);
    }
  }
}

export default ReportRepository;
